import { LinearProgress, alpha, withStyles } from '@material-ui/core';

export const ProgressBar = withStyles(theme => ({
  root: {
    // Reserve some space to the right so that it looks more aligned with the text
    // in the cell to the right.
    marginRight: theme.spacing(3),
    // Some space between the progress bar and the text below it.
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  colorSecondary: {
    backgroundColor:
      theme.palette.type === 'light'
        ? alpha(theme.palette.secondary.main, 0.1)
        : alpha(theme.palette.secondary.main, 0.3),
  },
}))(LinearProgress);
